import { t } from 'translations'

export const generateOnRefundErrorMessage = (error: Error, isCancellation: boolean, orderId: string) => {
    if (error.message) {
        if (error.message === 'incomplete_payment_data') {
            return isCancellation
                ? t('orders.utils.refundError.incompleteCancel', { orderId })
                : t('orders.utils.refundError.incompleteRefund', { orderId })
        }
        return t('orders.utils.refundError.withMessage', { orderId, message: error.message })
    }

    return isCancellation
        ? t('orders.utils.refundError.genericCancel', { orderId })
        : t('orders.utils.refundError.genericRefund', { orderId })
}
